import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useLogout } from '@refinedev/core';

import { Header, KitProvider, Sidebar } from '@rrexpress/core';

import BluebirdLogo from '@/assets/images/bluebird-mini.svg';
import useLayout from '@/hooks/useLayout';
import useSidebarMenu from '@/hooks/useSidebarMenu';

const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const { layout } = useLayout();
  const location = useLocation();
  const { mutate: logout } = useLogout();

  const { menu } = useSidebarMenu();

  return (
    <KitProvider projectName="custportal-web">
      <div className="flex h-screen bg-gray-100">
        <Sidebar
          title="Bluebird Kirim"
          logo={<img src={BluebirdLogo} />}
          menu={menu || []}
          pathname={location?.pathname}
          onNavigate={(path) => navigate(path)}
          description="Your One Stop Logistic Solutions Service"
        />
        <div className="w-full overflow-auto p-[1.5rem]">
          <Header
            title={layout.title || 'Customer Portal'}
            handleLogout={() => logout()}
            headerOptions={[
              {
                label: 'Profile',
                onClick: () => navigate('/profile'),
              },
            ]}
          />
          <main className="flex-grow flex-1 overflow-y-auto bg-gray-100">
            <div className="mx-auto my-5">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </KitProvider>
  );
};

export default MainLayout;
